import ApiService from './ApiService'

class UserService {
  static async getUser (id) {
    return ApiService.GET(`/api/users/edit/${id}.json`)
  }

  static async deleteUser (id) {
    return ApiService.POST(`/api/users/delete/${id}.json`)
  }

  static async getUsersByEquipmentId (equipmentId) {
    return ApiService.GET(`/api/users/get-users-by-equipment-id/${equipmentId}.json`)
  }

  static async getInspectors () {
    return ApiService.GET('/api/users/get-inspectors.json')
  }

  static async getDeps () {
    return ApiService.GET('/api/users/create.json')
  }

  static async createUser (data) {
    return ApiService.POST('/api/users/create.json', data)
  }

  static async saveUser (id, data) {
    return ApiService.POST(`/api/users/edit/${id}.json`, data)
  }

  static async profile () {
    return ApiService.GET('/api/users/profile')
  }

  static async saveProfile (data) {
    return ApiService.POST('/api/users/profile', data)
  }

  static async getUsers (query) {
    return ApiService.GET('/api/users/index', query)
  }
}

export default UserService
